import { RegistrationApi } from 'api';

export const useSendSmsCode = (setDialogType: any) => {
	const sendCode = async (email: string, emailConsent: boolean, mobile: string, smsConsent: boolean) => {
		if (email && mobile) {
			await RegistrationApi.sendSms({ email, emailConsent, mobile, smsConsent }).then(() => setDialogType('smsSent'));
		} else {
			setDialogType('error');
		}
	};

	return { sendCode };
};
